import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation LOGIN($email: String!, $password: String!) {
    goldwareLogin(email: $email, password: $password) {
      token
    }
  }
`;
